export enum GslCommonFields {
    count = 'count',
}
